import { motion } from "framer-motion";
import { WHY_US } from "@/constants/testIds";
import TiltCard from "@/components/TiltCard";
import { Check } from "lucide-react";

const ITEMS = [
    {
        slug: "custom",
        title: "Customised Growth Plans",
        copy: "Built for your brand, not copy-pasted from a slide deck.",
    },
    {
        slug: "organic",
        title: "100% Organic",
        copy: "Zero paid ads, ever. Every result comes from strategy and distribution.",
    },
    {
        slug: "reports",
        title: "Weekly Progress Reports",
        copy: "You see exactly what's moving: reach, saves, DMs, conversions.",
    },
    {
        slug: "support",
        title: "Dedicated Support",
        copy: "Direct line to our team. No ticket queues, no runaround.",
    },
    {
        slug: "data",
        title: "Data-Driven Systems",
        copy: "Audience psychology, algorithm behaviour, and market research behind every move.",
    },
    {
        slug: "contract",
        title: "No Long-Term Contracts",
        copy: "You stay because it works, not because you're locked in.",
    },
];

export default function WhyChooseUs() {
    return (
        <section
            id="why-us"
            data-testid={WHY_US.root}
            className="relative py-24 md:py-32"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-3xl">
                    <p className="text-xs uppercase tracking-[0.35em] text-[var(--accent-gold)] mb-5">
                        Why Choose Us
                    </p>
                    <h2 className="font-display font-bold text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-[var(--text-primary)]">
                        Six reasons brands{" "}
                        <span className="italic text-[var(--accent-champagne)]">
                            never look back.
                        </span>
                    </h2>
                </div>

                <div className="mt-14 md:mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 perspective-1000">
                    {ITEMS.map((it, i) => (
                        <motion.div
                            key={it.slug}
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.55, delay: (i % 3) * 0.08 }}
                        >
                            <TiltCard intensity={6} lift={8}>
                                <div
                                    data-testid={WHY_US.item(it.slug)}
                                    className="h-full rounded-2xl border border-[var(--border-subtle)] bg-[rgba(0,0,0,0.35)] hover:border-[var(--border-accent)] transition-all p-6 md:p-7 relative"
                                >
                                    <div className="w-11 h-11 rounded-xl bg-[rgba(212,175,55,0.12)] border border-[var(--border-accent)] flex items-center justify-center mb-5">
                                        <Check
                                            size={20}
                                            className="text-[var(--accent-gold)]"
                                            strokeWidth={2.5}
                                        />
                                    </div>
                                    <h3 className="font-display text-xl md:text-2xl font-semibold text-[var(--text-primary)] leading-tight mb-3">
                                        {it.title}
                                    </h3>
                                    <p className="text-sm md:text-base text-[var(--text-secondary)] leading-relaxed">
                                        {it.copy}
                                    </p>
                                </div>
                            </TiltCard>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
